import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import { IGeneralResponse } from '@/api/types'

export interface INewsAttributes {
  title: string
  description: string
  link: string
  logo: string
}

export interface INews {
  id: string
  type: 'marketingpost'
  attributes: INewsAttributes
}

export interface INewsResponse extends IGeneralResponse {
  data: Array<INews>
}

export const fetchItems = async (): Promise<INewsResponse> => {
  const params = {
    limit: 100,
    start: 0
  }
  const response = await apiClient.get<INewsResponse>('/marketing_posts', {
    params
  })
  return response.data
}
